module.exports = __webpack_public_path__ + "img/ma.9093d828.svg";